module.exports = require('./_global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** /Users/prosciutto/Works/Slam/~/core-js/modules/_html.js
 ** module id = 110
 ** module chunks = 0
 **/